import { render, staticRenderFns } from "./FolderItemLabelEditor.vue?vue&type=template&id=462a1b44&scoped=true&"
import script from "./FolderItemLabelEditor.vue?vue&type=script&lang=js&"
export * from "./FolderItemLabelEditor.vue?vue&type=script&lang=js&"
import style0 from "./FolderItemLabelEditor.vue?vue&type=style&index=0&id=462a1b44&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462a1b44",
  null
  
)

export default component.exports